<form class="form-cancelamento">
  <div class="modal-header">
    <h2>Descrição do motivo do cancelamento</h2>
    <button mat-icon-button type="button" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr />
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Descrição</mat-label>
    <textarea
      name="descricao"
      [(ngModel)]="reason"
      matInput
      maxlength="512"
    ></textarea>
    <mat-hint align="end">{{ reason().length || 0 }} / 512</mat-hint>
  </mat-form-field>
  <div class="buttons-footer-modal">
    <button mat-flat-button [mat-dialog-close]="reason()" type="submit">
      <mat-icon>save</mat-icon>
      Enviar
    </button>
  </div>
</form>
